
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getGradeSubjectListCount, getGradeSubjectList, gradeSubjectDelete, getAddGradeSubjectList, getGradeSubjectListNoPage, getAddGradeSubjectListCount, gradeSubjectInsert, deleteAllGradeSubject } from '@/api/enrollmentinformation'
import { queryCriteriaGradeBySchoolId } from '@/api/common/common'
import util from '@/utils/busi/util'

@Component({
  name: 'gradesubject',
  components: {
    SimpleTable,
    DictSelect
  }
})

export default class GradeSubject extends Vue {
  @Prop({ type: Object })
  private data!: object|any

  @Prop({ type: String })
  private flag!: string

  get isEdit () {
    return this.flag !== 'show'
  }

  private selecteds: any = []

  private dialogVisible = !1

  private emptyText = '请先选择’报读年级‘点击查询后查看数据！'

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [
    {
      prop: 'gradeName',
      label: '报读年级'
    },
    {
      prop: 'subjectCode',
      label: '专业代码'
    },
    {
      prop: 'subjectName',
      label: '专业名称'
    },
    {
      prop: 'degreeName',
      label: '学历层次'
    },
    {
      prop: 'lenName',
      label: '学制'
    }
  ]

  private async onRemove (row: any) {
    //
    this.$confirm('确认是否删除吗？', '删除', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(async (v: any) => {
      await gradeSubjectDelete({
        id: row.id || -999
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message('刪除成功')
          this.initTable()
        }
      })
    })
  }

  private onAdd () {
    this.dialogVisible = !0
  }

  private onDeleteAll () {
    this.$confirm('此操作将删除所有已添加的年级专业, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteAllGradeSubject({
            schoolId:this.schoolId
        }).then(res=>{
            this.$message('刪除成功')
            // 获取已配置列表
            this.initTable()
        }).catch(() => {
            this.$message('刪除失败')
        });
    }).catch(() => {
    });
  }

  private onBack () {
    this.dialogVisible = !1
  }

  private gradeData: any = []

  private async open () {
    this.onReset()
    this.selecteds = []
    this.dialogTableData = {
      list: [],
      totalCount: 0
    }
    await queryCriteriaGradeBySchoolId({
      schoolId: this.schoolId
    }).then((res: any) => {
      if (res.code === 10000) {
        this.gradeData = res.object.list
      }
    })
    await getGradeSubjectListNoPage({
      schoolId: this.schoolId
      // gradeId: this.form.gradeId,
      // subjectCode: this.form.subjectCode,
      // subjectName: this.form.subjectName
    }).then((res: any) => {
      if (res.code === 10000) {
        res.object.list.map((v: any) => {
          this.selecteds.push({
            ...v,
            id: v.gradeId + '-' + v.subjectId,
            showVal: `${v.gradeName}-[${v.degreeName}]${v.subjectName}[${v.lenName}年]`
          })
        })
      }
    })
  }

  private async initTable (pagination: any = null) {
    await getGradeSubjectList({
      gradeId: this.data.gradeId,
      subjectId: this.data.subjectId,
      schoolId: this.schoolId,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      if (res.code === 10000) {
        await getGradeSubjectListCount({
          gradeId: this.data.gradeId,
          subjectId: this.data.subjectId,
          schoolId: this.schoolId
        }).then((resCnt: any) => {
          this.tableData = {
            list: res.object.list,
            totalCount: resCnt.object.totalCount
          }
        })
      }
    })
  }

  private form: any = {
    gradeId: '',
    subjectCode: '',
    subjectName: ''
  }

  private onReset () {
    this.form = {
      gradeId: '',
      subjectCode: '',
      subjectName: ''
    }
    this.dialogTableData = {
      list: [],
      totalCount: 0
    }
    this.emptyText = '请先选择’报读年级‘点击查询后查看数据！'
  }

  private dialogPagination = {
    currentPage: 1,
    pageSize: 10
  }

  private dialogTableData = {
    list: [],
    totalCount: 0
  }

  private dialogColumns = [
    {
      prop: 'gradeName',
      label: '报读年级'
    },
    {
      prop: 'subjectCode',
      label: '专业代码'
    },
    {
      prop: 'subjectName',
      label: '专业名称'
    },
    {
      prop: 'degreeName',
      label: '学历层次'
    },
    {
      prop: 'lenName',
      label: '学制'
    },
    // {
    //   prop: 'feeStandardMoney',
    //   label: '预缴（元）'
    // }
  ]

  get schoolId () {
    return util.getRouterParams().schoolId
  }

  private async close (id: any) {
    this.selecteds = this.selecteds.filter((val: any) => val.id !== id)
  }

  private async onQuery (pagination: any = null) {
    // this.selecteds = []
    if (!this.form.gradeId && this.isEdit) {
      this.$alert('请选择年级', { type: 'error' })
      return
    }
    !pagination && (this.dialogPagination.currentPage = 1)
    await getAddGradeSubjectList({
      schoolId: this.schoolId,
      gradeId: this.form.gradeId,
      subjectCode: this.form.subjectCode,
      subjectName: this.form.subjectName,
      ...pagination || this.dialogPagination
    }).then(async (res: any) => {
      if (res.code === 10000) {
        await getAddGradeSubjectListCount({
          schoolId: this.schoolId,
          gradeId: this.form.gradeId,
          subjectCode: this.form.subjectCode,
          subjectName: this.form.subjectName
        }).then((resCnt: any) => {
          if (res.code === 10000) {
            this.dialogTableData.list = res.object.list.map((v: any) => {
              v.feeStandardMoney = v.feeStandardMoney / 100
              v.id = v.gradeId + '-' + v.subjectId
              return v
            })
            this.dialogTableData.totalCount = resCnt.object.totalCount
            if (resCnt.object.totalCount === 0) {
              this.emptyText = '未找到专业信息，请先配置专业或收费标准'
            }
          }
        })
      }
    })
  }

  private rowClick (row: any) {
    let flag = !1
    this.selecteds.map((val: any) => {
      if (row.id === val.id) {
        flag = !0
      }
    })
    flag || this.selecteds.push({
      ...row,
      showVal: `${row.gradeName}-${row.subjectName}`
    } as never)
  }

  private async onSubmit () {
    const datas: any = []
    if (this.selecteds.length === 0) {
      this.$message.error('请选择至少一个年级专业')
      return
    }
    this.selecteds.map((v: any) => {
      datas.push({
        schoolId: v.schoolId,
        gradeId: v.gradeId,
        subjectId: v.subjectId
      } as never)
    })

    await gradeSubjectInsert(datas as any).then((res: any) => {
      if (res.code === 10000) {
        this.dialogVisible = !1
        this.initTable()
        this.$message(res.message)
      } else {
        this.$alert(res.message, { type: 'error' })
      }
    })
  }

  private rowClassName ({ row }: any) {
    const flag = this.selecteds.filter((v: any) => v.id === row.id)
    return flag.length > 0 ? 'active' : ''
  }

  beforeMount () {
    this.initTable()
  }
}
